import { render, staticRenderFns } from "./OrderPreviewContent.vue?vue&type=template&id=2aea2314&scoped=true"
import script from "./OrderPreviewContent.vue?vue&type=script&lang=ts"
export * from "./OrderPreviewContent.vue?vue&type=script&lang=ts"
import style0 from "./OrderPreviewContent.vue?vue&type=style&index=0&id=2aea2314&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea2314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aea2314')) {
      api.createRecord('2aea2314', component.options)
    } else {
      api.reload('2aea2314', component.options)
    }
    module.hot.accept("./OrderPreviewContent.vue?vue&type=template&id=2aea2314&scoped=true", function () {
      api.rerender('2aea2314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/OrderPreviewContent.vue"
export default component.exports